import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { inject } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';
import { UtilitiesService } from '../services/utilities.service';
import { initPopupData } from '../model/popup-data';

export const uriInterceptor: HttpInterceptorFn = (req, next) => {
  const cookieService = inject(CookieService);
  const router = inject(Router);
  const utilities = inject(UtilitiesService);

  if (req.url.indexOf('assets/icons') > -1) {
    let domain = environment.domain;
    if (domain === 'localhost') {
      domain = 'http://' + domain + ':4200/';
    } else {
      domain = 'https://' + domain;
    }
    const header = req.headers.set('Access-Control-Allow-Origin', '*');
    const url = domain + req.url;
    const iconRequest = req.clone({ url: url, headers: header });
    return next(iconRequest);
  }

  // Skip URL modification for absolute URLs (external requests like S3 presigned URLs)
  if (req.url.startsWith('http://') || req.url.startsWith('https://')) {
    return next(req);
  }

  let url = req.url;
  url = `${environment.apiUrl}${url}`;

  const token = 'Bearer ' + cookieService.get('token');
  const fdIdtoken = cookieService.get('fdIdAccessToken')
  let headers = req.headers.set('Access-Control-Allow-Origin', '*');
  headers = headers.set('Authorization', token);
  headers = headers.set('fdIdAccessToken', fdIdtoken)
  const fdClientId = utilities.clientId;
  if (fdClientId) {
    headers = headers.set('fdClientId', fdClientId.toString());
  }

  const apiRequest = req.clone({ url: url, headers: headers, body: req.body });

  return next(apiRequest).pipe(
    catchError((error) => {
      if (error.status === 401) {
        if (router.url !== '/login') {
          const popupData = initPopupData;
          popupData.title = 'Session Expired';
          popupData.content = 'Your session has expired. Please log in again.',
            popupData.warn = true;
          utilities.showSnackbarAlert(
            popupData
          );
        }
        cookieService.deleteAll();
        router.navigate(['/login']);

        return throwError(() => error);
      }
      return throwError(() => error);
    })
  );
};